<template>
	<v-row>
		<v-col class="d-flex flex-wrap align-center">
			<service v-for="service in services" :key="service.id" :service="service" class="ma-4" />
		</v-col>
	</v-row>
</template>

<script>
import Service from './components/Service'

export default {
	name: 'Services',

	components: { Service },

	data() {
		return {
			services: []
		}
	},

	async created() {
		let { data } = await this.$http.get('services')
		this.services = data
	}
}
</script>

<style lang="scss" scoped></style>
